import React from 'react';
import {
  TouchableOpacity,
  StyleSheet,
  ViewStyle,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, spacing } from '../theme';

export interface SocialButtonProps {
  provider: 'google' | 'facebook' | 'apple';
  onPress: () => void;
  style?: ViewStyle;
}

export const SocialButton: React.FC<SocialButtonProps> = ({
  provider,
  onPress,
  style,
}) => {
  const getProviderInfo = () => {
    switch (provider) {
      case 'google':
        return {
          icon: 'logo-google' as keyof typeof Ionicons.glyphMap,
          backgroundColor: '#4285F4',
        };
      case 'facebook':
        return {
          icon: 'logo-facebook' as keyof typeof Ionicons.glyphMap,
          backgroundColor: '#1877F2',
        };
      case 'apple':
        return {
          icon: 'logo-apple' as keyof typeof Ionicons.glyphMap,
          backgroundColor: '#000000',
        };
      default:
        return {
          icon: 'logo-google' as keyof typeof Ionicons.glyphMap,
          backgroundColor: colors.primary,
        };
    }
  };

  const providerInfo = getProviderInfo();

  return (
    <TouchableOpacity
      style={[
        styles.button,
        { backgroundColor: providerInfo.backgroundColor },
        style,
      ]}
      onPress={onPress}
      activeOpacity={0.8}
    >
      <Ionicons 
        name={providerInfo.icon} 
        size={24} 
        color={colors.white} 
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    flex: 1,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.md,
    borderRadius: spacing.borderRadius.md,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: spacing.xs,
    minHeight: 48,
    width: 48,
  },
});
